import { render, staticRenderFns } from "./AscTextareaInput.vue?vue&type=template&id=3e6a4800&"
import script from "./AscTextareaInput.vue?vue&type=script&lang=js&"
export * from "./AscTextareaInput.vue?vue&type=script&lang=js&"
import style0 from "./AscTextareaInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCounter } from 'vuetify/lib/components/VCounter';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCounter,VTextarea})
